import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IGetVodPayload,
  IVodState,
  ICreateVodPayload,
  IUpdateVodPayload,
  IDeleteVodPayload,
} from "../../../interfaces/store/vod-interface";

const initialState: IVodState = {
  vod: null,
  error: null,
  loading: false,
  requestState: "prepare",
  operation: null,
};

const _getVodStart = (
  state: IVodState,
  { payload }: PayloadAction<IGetVodPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getVodSuccess = (
  state: IVodState,
  { payload }: PayloadAction<any>
) => {
  state.vod = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getVodFailed = (
  state: IVodState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetVod = (state: IVodState) => {
  state.vod = null;
  state.error = null;
  state.loading = false;
  state.requestState = "prepare";
  state.operation = null;
};

const _createVodStart = (
  state: IVodState,
  { payload }: PayloadAction<ICreateVodPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "create";
};

const _createVodSuccess = (
  state: IVodState,
  { payload }: PayloadAction<any>
) => {
  state.vod = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _createVodFailed = (
  state: IVodState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.vod = null;
  state.requestState = "error";
};

const _updateVodStart = (
  state: IVodState,
  { payload }: PayloadAction<IUpdateVodPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateVodSuccess = (
  state: IVodState,
  { payload }: PayloadAction<any>
) => {
  state.vod = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
  state.operation = "update";
};

const _updateVodFailed = (
  state: IVodState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.vod = null;
  state.requestState = "error";
};

const _deleteVodStart = (
  state: IVodState,
  { payload }: PayloadAction<IDeleteVodPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "delete";
};

const _deleteVodSuccess = (
  state: IVodState,
  { payload }: PayloadAction<any>
) => {
  state.vod = null;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _deleteVodFailed = (
  state: IVodState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.vod = null;
  state.requestState = "error";
};

const VodSlice = createSlice({
  name: "vod",
  initialState,
  reducers: {
    getVodStart: _getVodStart,
    getVodSuccess: _getVodSuccess,
    getVodFailed: _getVodFailed,
    resetVod: _resetVod,
    createVodStart: _createVodStart,
    createVodSuccess: _createVodSuccess,
    createVodFailed: _createVodFailed,
    updateVodStart: _updateVodStart,
    updateVodSuccess: _updateVodSuccess,
    updateVodFailed: _updateVodFailed,
    deleteVodStart: _deleteVodStart,
    deleteVodSuccess: _deleteVodSuccess,
    deleteVodFailed: _deleteVodFailed,
  },
});

export const {
  getVodStart,
  getVodSuccess,
  getVodFailed,
  resetVod,
  createVodStart,
  createVodSuccess,
  createVodFailed,
  updateVodStart,
  updateVodSuccess,
  updateVodFailed,
  deleteVodStart,
  deleteVodSuccess,
  deleteVodFailed,
} = VodSlice.actions;
export default VodSlice.reducer;
